module.exports = __webpack_public_path__ + "img/character-3.592fb2de.webp";